export default __webpack_public_path__ + "static/media/service3.edd018f1.jpg";